import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { MediumService } from "../../../services/medium-service";

export const Mediumeditcontent = (props) => {

  const [submitloading, setSubmitLoading] = useState(true);

  const { mediumId } = useParams();

  useEffect(() => {
    mediumSearchID();
  }, []);

  const [mediumInfo, setMediumInfo] = useState({
    name: "",
    status: "",
  });

  const mediumSearchID = async () => {
    try {
      const result = await MediumService.mediumDetailsID(mediumId);
      const info = {};

      const mediumdata = result;

      info.name = mediumdata.name;
      info.status = mediumdata.status;

      setMediumInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {

      //todo extra validations
      setSubmitLoading(false);

      try {
        await MediumService.mediumUpdate(mediumId, values);

        setSubmitLoading(true);
        notify("Medium successfully updated");
      } catch (err) {
        setSubmitLoading(true);
        //show error toast
        if (err.response.data.message !== undefined) {
          notifyWarning(err.response.data.message);
        } else {
          notifyWarning("Something Wrong");
        }
      }
    
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  name: mediumInfo.name,
                  status: mediumInfo.status,
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required("Required")
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                  setFieldValue,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom18">Name</label>
                        <div className="input-group">
                          <input
                            name="name"
                            type="text"
                            className="form-control"
                            id="nameid"
                            placeholder="Name"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.name && errors.name}
                        </div>
                      </div>
                      <div className="col-md-6 mb-6">
                        <label htmlFor="validationCustom15">Status</label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="selectstatus"
                            required
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="DISABLED">DISABLED</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.status && errors.status}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>

                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Save and Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mediumeditcontent;
